// Module
var code = "<div id=\"{{elementId}}\" width=\"100%\" height=\"auto\"></div>";
// Exports
export default code;